/*=========================================================================================
  File Name: moduleSpaceGetters.js
  Description: Space Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  // getTask: state => (id) => state.notices.find((notice) => notice.id == id)
  // getNotice: state => (id) => state.notices.find((notice) => notice.id == id)
  getBlog: state => (id) => state.blogs.find((blog) => blog.id == id),
  getTask: state => (id) => state.tasks.find((task) => task.id == id),
  getProjectMembers: state => (id) => state.projectMembers.find((member) => member.user_id == id)
}
